enum EButtonType {
    primary = 'primary',
    secondary = 'secondary',
    tertiary = 'tertiary',
    danger = 'danger',
    warning = 'warning',
    image = 'image',
};

export default EButtonType;